import { useState, useEffect } from "react"
import { useApp } from "../../context/useApp"
import Swal from "sweetalert2"
import { Link, useParams } from "react-router-dom"
import {
  administrationValues,
  agreementTimes,
  notificationTimes,
  tools,
  notaries,
  propertyTypes,
  documents,
} from "./create-property-data"
import DateInput from "../../components/DateInput"
import { searchQuery } from "../../actions/global-actions"
import { getProperty, updateProperty } from "../../actions/property-actions"
import { provinces } from "actions/global-actions-data"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { alert } from "components/Alert"
import {
  FaHome,
  FaMapMarkerAlt,
  FaFileAlt,
  FaBuilding,
  FaDollarSign,
  FaUser,
  FaCalendarAlt,
  FaPiggyBank,
  FaCog,
  FaClipboard,
  FaRuler,
  FaGavel,
  FaPercent,
  FaBell,
  FaTag,
} from "react-icons/fa"

function EditProperty() {
  const currentLink = "/inmuebles"
  const { user, setLoading } = useApp()
  const [loadData, setLoadData] = useState(true)
  const params = useParams()

  // Función helper para normalizar valores null/undefined a string vacío
  const normalizeValue = (value) => {
    return value === null || value === undefined ? "" : value
  }

  const [form, setForm] = useState({
    propertyType: "",
    use: "",
    address: "",
    neighborhood: "",
    province: "",
    city: "",
    description: "",
    floorsNumber: "",
    monthCost: "",
    hasAdministrationFee: false,
    feeIncluded: false,
    administrationCost: "",
    realEstateRegistration: "",
    propertyNumber: "",
    publicDeedNumber: "",
    publicDeedDate: "",
    notary: "",
    servicesBill: "",
    gasBill: "",
    managementTime: "",
    managementPercentage: "",
    owner: {
      userID: "",
    },
    ownerText: "",
    administrator: {
      userID: "",
    },
    administratorText: "",
    code: "",
    minimumNotificationTime: "",
    bankAccount: {
      _id: "",
      bank: "",
      accountType: "",
      accountNumber: "",
      owner: "",
    },
  })

  const forLink = process.env.REACT_APP_LINK

  const [dropdown, setDropdown] = useState({
    show: false,
    value: "",
    data: [],
  })

  const [citiesData, setCitiesData] = useState({
    showCities: false,
    cities: [],
  })

  const [accounts, setAccounts] = useState([])
  const [links, setLinks] = useState([])
  const [formErrors, setFormErrors] = useState({})

  useEffect(() => {
    if (loadData) {
      ;(async () => {
        try {
          const data = await getProperty(params.id, setLoading, user.token)
          if (data.code === "01") {
            alert("Error", data.message)
            return
          }

          const propertyObj = data.data[0]
          let newLinks = JSON.parse(JSON.stringify(tools))
          newLinks.map((link) => {
            if (link.name === "Copiar link solicitud") {
              link.value = `/solicitud/${propertyObj.code}`
              return link
            }
            link.value = `${currentLink}/${params.id}/${link.value}`
            return link
          })
          setLinks(newLinks)

          // Manejar tanto array (de $lookup) como objeto (de populate)
          const owner = Array.isArray(propertyObj.owner.userID) 
            ? propertyObj.owner.userID[0] 
            : propertyObj.owner.userID
          const administrator = Array.isArray(propertyObj.administrator.userID) 
            ? propertyObj.administrator.userID[0] 
            : propertyObj.administrator.userID

          let ownerText = `${owner?.firstName || ""} ${owner?.lastName || ""} ${owner?.documentType || ""} ${owner?.document || ""}`.trim()
          let administratorText = `${administrator?.firstName || ""} ${administrator?.lastName || ""} ${administrator?.documentType || ""} ${administrator?.document || ""}`.trim()

          let publicDeedDate = new Date(data.data[0].publicDeedDate)

          setAccounts([...(administrator?.bankAccount || [])])
          const currentAccount =
            (administrator?.bankAccount || []).filter(
              (x) => x.accountNumber === propertyObj.bankAccount.accountNumber,
            )[0]
          const cities = provinces.find(
            (x) => x.name === propertyObj.province,
          ).cities

          setCitiesData({
            showCities: true,
            cities,
          })

          setForm({
            ...form,
            _id: normalizeValue(propertyObj._id),
            propertyType: normalizeValue(propertyObj.propertyType),
            use: normalizeValue(propertyObj.use),
            address: normalizeValue(propertyObj.address),
            neighborhood: normalizeValue(propertyObj.neighborhood),
            province: normalizeValue(propertyObj.province),
            city: normalizeValue(propertyObj.city),
            description: normalizeValue(propertyObj.description),
            floorsNumber: normalizeValue(propertyObj.floorsNumber),
            monthCost: normalizeValue(propertyObj.monthCost),
            hasAdministrationFee: propertyObj.hasAdministrationFee || false,
            feeIncluded: propertyObj.feeIncluded || false,
            administrationCost: normalizeValue(propertyObj.administrationCost),
            realEstateRegistration: normalizeValue(
              propertyObj.realEstateRegistration,
            ),
            propertyNumber: normalizeValue(propertyObj.propertyNumber),
            publicDeedNumber: normalizeValue(propertyObj.publicDeedNumber),
            notary: normalizeValue(propertyObj.notary),
            servicesBill: normalizeValue(propertyObj.servicesBill),
            gasBill: normalizeValue(propertyObj.gasBill),
            managementTime: normalizeValue(propertyObj.managementTime),
            managementPercentage: normalizeValue(
              propertyObj.managementPercentage,
            ),
            code: normalizeValue(propertyObj.code),
            minimumNotificationTime: normalizeValue(
              propertyObj.minimumNotificationTime,
            ),
            owner: {
              userID: normalizeValue(owner._id),
            },
            ownerText,
            administrator: {
              userID: normalizeValue(administrator._id),
            },
            administratorText,
            publicDeedDate,
            bankAccount: {
              ...form.bankAccount,
              ...currentAccount,
            },
          })
        } catch (error) {
          console.error("Error loading property:", error)
        }
      })()

      setLoadData(false)

      setForm({
        propertyType: "",
        use: "",
        address: "",
        neighborhood: "",
        province: "",
        city: "",
        description: "",
        floorsNumber: "",
        monthCost: "",
        hasAdministrationFee: false,
        feeIncluded: false,
        administrationCost: "",
        realEstateRegistration: "",
        propertyNumber: "",
        publicDeedNumber: "",
        publicDeedDate: "",
        notary: "",
        servicesBill: "",
        gasBill: "",
        managementTime: "",
        managementPercentage: "",
        owner: {
          userID: "",
        },
        ownerText: "",
        administrator: {
          userID: "",
        },
        administratorText: "",
        code: "",
        minimumNotificationTime: "",
        bankAccount: {
          _id: "",
          bank: "",
          accountType: "",
          accountNumber: "",
          owner: "",
        },
      })
      setLinks([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadData, params.id, user.token])

  const handleInputChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    })
  }

  const handleCheckChange = (event) => {
    const { name, checked } = event.target

    if (name === "hasAdministrationFee" && !checked) {
      // Si deselecciona hasAdministrationFee, resetear campos dependientes
      setForm({
        ...form,
        [name]: checked,
        administrationCost: "",
        feeIncluded: false,
      })
    } else {
      setForm({
        ...form,
        [name]: checked,
      })
    }
  }

  const handleSearchChange = (event) => {
    const value = event.target.value || ""
    setForm({
      ...form,
      [event.target.name]: value,
    })
    if (value && value.length > 2) {
      setLoading(true)
      searchQuery(event.target.id, value, event.target.name, user.token)
        .then((response) => {
          searchFunction(response.key, response.data)
        })
        .catch((error) => {
          console.error("Search error:", error)
        })
        .finally(() => setLoading(false))
    } else {
      setDropdown({ show: false, value: "", data: [] })
    }
  }

  const searchFunction = (link, data) => {
    if (!data) {
      setDropdown({ show: false, value: "", data: [] })
      return
    }
    if (data.code === "01") {
      Swal.fire({
        title: "Error",
        confirmButtonColor: "#76b4ff",
        text: data.message,
      })
      setDropdown({ show: false, value: "", data: [] })
    } else {
      console.log(data)
      setDropdown({
        show: true,
        value: link,
        data: Array.isArray(data.data) ? data.data : [],
      })
    }
  }

  const setOwner = (data) => {
    setForm({
      ...form,
      owner: {
        userID: data._id,
      },
      ownerText:
        data.firstName +
        " " +
        data.lastName +
        " " +
        data.documentType +
        ": " +
        data.document,
    })
    setDropdown({ show: false, value: "", data: [] })
  }

  const setAdministrator = (data) => {
    setAccounts([...data.bankAccount])
    setForm({
      ...form,
      administrator: {
        userID: data._id,
      },
      administratorText:
        data.firstName +
        " " +
        data.lastName +
        " " +
        data.documentType +
        ": " +
        data.document,
    })
    setDropdown({ show: false, value: "", data: [] })
  }

  const handleOnChange = (event) => {
    const value = event.target.value
    if (value !== "" && value) {
      const cities = provinces.find((x) => x.name === value).cities
      setCitiesData({
        showCities: true,
        cities,
      })
      setForm({
        ...form,
        [event.target.name]: event.target.value,
      })
    } else {
      setCitiesData({
        showCities: false,
        cities: [],
      })
      setForm({
        ...form,
        city: "",
        province: "",
      })
    }
  }

  const handleDateChange = (name, date) => {
    setForm({
      ...form,
      [name]: date,
    })
  }

  const handleAccountChange = (event) => {
    const currentAccount = accounts.filter(
      (x) => x._id === event.target.value,
    )[0]
    setForm({
      ...form,
      bankAccount: currentAccount,
    })
  }

  const handleOnSubmit = async (event) => {
    event.preventDefault()
    const errors = validateFields()
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors)
      Swal.fire({
        title: "¡Atención!",
        confirmButtonColor: "#76b4ff",
        text: "Debe llenar todos los datos de manera correcta para continuar",
      })
      return
    } else {
      try {
        const result = await updateProperty(form, setLoading, user.token)

        if (result.data.code === "01") {
          Swal.fire({
            title: "Error",
            confirmButtonColor: "#76b4ff",
            text: result.data.message,
          })

          return
        }
        setLoadData(true)
        setFormErrors({})
        Swal.fire({
          title: "¡Éxito!",
          confirmButtonColor: "#76b4ff",
          text: "Inmueble actualizado con éxito",
        })
      } catch (error) {
        console.error("Error updating property:", error)
      }
    }
  }

  const validateFields = () => {
    const errors = {}
    // Si es tipo comercial, 'use' es obligatorio
    const commercialTypes = ["Local", "Bodega", "Oficina"]
    if (commercialTypes.includes(form.propertyType)) {
      if (form.use === "") {
        errors["use"] = true
      }
    }

    for (const field in form) {
      if (form.hasOwnProperty(field)) {
        if (
          field !== "administrationCost" &&
          field !== "floorsNumber" &&
          field !== "realEstateRegistration" &&
          field !== "propertyNumber" &&
          field !== "publicDeedNumber" &&
          field !== "publicDeedDate" &&
          field !== "notary" &&
          field !== "servicesBill" &&
          field !== "gasBill" &&
          field !== "use" &&
          form[field] === ""
        ) {
          errors[field] = true
        }
      }
    }

    // Validar cuenta bancaria
    if (form.bankAccount.bank === "") {
      errors["bankAccount"] = true
    }

    return errors
  }

  useEffect(() => {
    //console.log('form', form)
    //console.log('accounts', accounts)
  }, [form, accounts])

  return (
    <div className="w-100 d-flex">
      <div className="container d-flex flex-column">
        <div className="w-100 mt-5">
          <Link to={currentLink} className="back-button">
            &#60; Volver - Lista de inmuebles
          </Link>
        </div>
        <h1 className="my-5">
          <FaHome className="me-2" style={{ color: "#76b4ff" }} />
          Editar inmueble {form.code}
        </h1>
        <form onSubmit={handleOnSubmit}>
          <div className="d-flex w-100 flex-wrap">
            {/* Datos Generales */}
            <div className="w-100 mb-4">
              <h4 className="w-100 mb-3 pb-2 border-bottom">
                <FaClipboard className="me-2" style={{ color: "#76b4ff" }} />
                Datos generales
              </h4>
            </div>

            <div className="d-flex flex-column w-25 field">
              <label className="label-field" htmlFor="code">
                <FaHome className="me-2" style={{ fontSize: "0.85em" }} />
                Código
              </label>
              <input
                id="code"
                name="code"
                autoComplete="off"
                maxLength={5}
                className={`input-field ${formErrors["code"] ? "input-error" : ""}`}
                type="text"
                onChange={handleInputChange}
                value={form.code}
              />
            </div>

            <div className="d-flex flex-column w-25 field">
              <label className="label-field" htmlFor="propertyType">
                <FaBuilding className="me-2" style={{ fontSize: "0.85em" }} />
                Tipo de propiedad
              </label>
              <select
                className={`input-field ${formErrors["propertyType"] ? "input-error" : ""}`}
                id="propertyType"
                name="propertyType"
                onChange={handleInputChange}
                value={form.propertyType}
              >
                <option></option>
                {propertyTypes.map((type, index) => (
                  <option key={`${type}${index}`} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            {/* Campo de Uso - Solo para Local, Bodega y Oficina */}
            {(form.propertyType === "Local" ||
              form.propertyType === "Bodega" ||
              form.propertyType === "Oficina") && (
              <div className="d-flex flex-column w-25 field">
                <label className="label-field" htmlFor="use">
                  <FaTag className="me-2" style={{ fontSize: "0.85em" }} />
                  Uso del inmueble
                </label>
                <input
                  className={`input-field ${formErrors["use"] ? "input-error" : ""}`}
                  id="use"
                  name="use"
                  type="text"
                  placeholder="Ej: Comercio, Servicios, Oficinas..."
                  onChange={handleInputChange}
                  value={form.use}
                  maxLength={100}
                  required
                />
              </div>
            )}

            <div className="d-flex flex-column w-25 field">
              <label className="label-field" htmlFor="province">
                <FaMapMarkerAlt
                  className="me-2"
                  style={{ fontSize: "0.85em" }}
                />
                Departamento
              </label>
              <select
                className={`input-field ${formErrors["province"] ? "input-error" : ""}`}
                id="province"
                name="province"
                onChange={handleOnChange}
                value={form.province}
              >
                <option></option>
                {provinces.map((province) => (
                  <option key={province.name} value={province.name}>
                    {province.name}
                  </option>
                ))}
              </select>
            </div>

            {citiesData.showCities && citiesData.cities.length > 0 && (
              <div className="d-flex flex-column w-25 field">
                <label className="label-field" htmlFor="city">
                  <FaMapMarkerAlt
                    className="me-2"
                    style={{ fontSize: "0.85em" }}
                  />
                  Ciudad
                </label>
                <select
                  className={`input-field ${formErrors["city"] ? "input-error" : ""}`}
                  id="city"
                  name="city"
                  onChange={handleInputChange}
                  value={form.city}
                >
                  <option></option>
                  {citiesData.cities.map((city) => (
                    <option key={city.name} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="d-flex flex-column w-25 field">
              <label className="label-field" htmlFor="address">
                <FaMapMarkerAlt
                  className="me-2"
                  style={{ fontSize: "0.85em" }}
                />
                Dirección
              </label>
              <input
                id="address"
                name="address"
                autoComplete="off"
                maxLength={180}
                className={`input-field ${formErrors["address"] ? "input-error" : ""}`}
                type="text"
                onChange={handleInputChange}
                value={form.address}
              />
            </div>

            <div className="d-flex flex-column w-25 field">
              <label className="label-field" htmlFor="neighborhood">
                <FaMapMarkerAlt
                  className="me-2"
                  style={{ fontSize: "0.85em" }}
                />
                Barrio
              </label>
              <input
                id="neighborhood"
                name="neighborhood"
                autoComplete="off"
                maxLength={60}
                className={`input-field ${formErrors["neighborhood"] ? "input-error" : ""}`}
                type="text"
                onChange={handleInputChange}
                value={form.neighborhood}
              />
            </div>

            <div className="d-flex flex-column w-25 field">
              <label className="label-field" htmlFor="floorsNumber">
                <FaRuler className="me-2" style={{ fontSize: "0.85em" }} />
                Número de pisos (Opcional)
              </label>
              <input
                id="floorsNumber"
                name="floorsNumber"
                autoComplete="off"
                type="number"
                className={`input-field ${formErrors["floorsNumber"] ? "input-error" : ""}`}
                onChange={handleInputChange}
                value={form.floorsNumber}
              />
            </div>

            {/* Datos Económicos */}
            <div className="w-100 mb-4 mt-4">
              <h4 className="w-100 mb-3 pb-2 border-bottom">
                <FaDollarSign className="me-2" style={{ color: "#76b4ff" }} />
                Datos económicos
              </h4>
            </div>

            <div className="d-flex flex-column w-33 field">
              <label className="label-field" htmlFor="monthCost">
                <FaDollarSign className="me-2" style={{ fontSize: "0.85em" }} />
                Canon mensual
              </label>
              <input
                id="monthCost"
                name="monthCost"
                autoComplete="off"
                type="number"
                min="0"
                className={`input-field ${formErrors["monthCost"] ? "input-error" : ""}`}
                onChange={handleInputChange}
                value={form.monthCost}
              />
            </div>

            {form.hasAdministrationFee && (
              <div className="d-flex flex-column w-33 field">
                <label className="label-field" htmlFor="administrationCost">
                  <FaCog className="me-2" style={{ fontSize: "0.85em" }} />
                  Costo administración
                </label>
                <input
                  id="administrationCost"
                  name="administrationCost"
                  autoComplete="off"
                  type="number"
                  min="0"
                  className={`input-field ${formErrors["administrationCost"] ? "input-error" : ""}`}
                  onChange={handleInputChange}
                  value={form.administrationCost}
                />
              </div>
            )}

            <div className="d-flex flex-column w-33 field d-flex align-items-end">
              <label className="label-field" style={{ marginBottom: "20px" }}>
                <FaCog className="me-2" style={{ fontSize: "0.85em" }} />
                Opciones
              </label>
              <div style={{ display: "flex", gap: "20px" }}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <input
                    type="checkbox"
                    id="hasAdministrationFee"
                    name="hasAdministrationFee"
                    onChange={handleCheckChange}
                    checked={form.hasAdministrationFee}
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <label
                    htmlFor="hasAdministrationFee"
                    style={{ margin: 0, cursor: "pointer", fontSize: "0.9em" }}
                  >
                    ¿Con costo?
                  </label>
                </div>
                {form.hasAdministrationFee && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="feeIncluded"
                      name="feeIncluded"
                      onChange={handleCheckChange}
                      checked={form.feeIncluded}
                      style={{
                        width: "18px",
                        height: "18px",
                        cursor: "pointer",
                      }}
                    />
                    <label
                      htmlFor="feeIncluded"
                      style={{
                        margin: 0,
                        cursor: "pointer",
                        fontSize: "0.9em",
                      }}
                    >
                      ¿Incluida?
                    </label>
                  </div>
                )}
              </div>
            </div>

            {/* Descripción */}
            <div className="w-100 mb-4 mt-4">
              <h4 className="w-100 mb-3 pb-2 border-bottom">
                <FaClipboard className="me-2" style={{ color: "#76b4ff" }} />
                Descripción del predio
              </h4>
            </div>

            <div className="d-flex flex-column w-100 field">
              <label className="label-field" htmlFor="description">
                <FaFileAlt className="me-2" style={{ fontSize: "0.85em" }} />
                Breve descripción
              </label>
              <textarea
                id="description"
                name="description"
                placeholder="Describe brevemente el predio..."
                autoComplete="off"
                rows={4}
                className={`input-field ${formErrors["description"] ? "input-error" : ""}`}
                onChange={handleInputChange}
                value={form.description}
              />
            </div>

            {/* Datos Particulares */}
            <div className="w-100 mb-4 mt-4">
              <h4 className="w-100 mb-3 pb-2 border-bottom">
                <FaFileAlt className="me-2" style={{ color: "#76b4ff" }} />
                Datos particulares
              </h4>
              <span
                className="span-field field w-100"
                style={{ fontSize: "0.9em", color: "#666" }}
              >
                Los datos a continuación son opcionales, pero necesarios para la
                generación de documentos
              </span>
            </div>

            <div className="d-flex flex-column w-3 field">
              <label className="label-field" htmlFor="realEstateRegistration">
                <FaFileAlt className="me-2" style={{ fontSize: "0.85em" }} />
                registro inmobiliario
              </label>
              <input
                id="realEstateRegistration"
                name="realEstateRegistration"
                autoComplete="off"
                maxLength={70}
                className={`input-field ${formErrors["realEstateRegistration"] ? "input-error" : ""}`}
                type="text"
                onChange={handleInputChange}
                value={form.realEstateRegistration}
                placeholder="Número de registro"
              />
            </div>

            <div className="d-flex flex-column w-3 field">
              <label className="label-field" htmlFor="propertyNumber">
                <FaFileAlt className="me-2" style={{ fontSize: "0.85em" }} />
                predial
              </label>
              <input
                id="propertyNumber"
                name="propertyNumber"
                autoComplete="off"
                maxLength={70}
                className={`input-field ${formErrors["propertyNumber"] ? "input-error" : ""}`}
                type="text"
                onChange={handleInputChange}
                value={form.propertyNumber}
                placeholder="Número de predial"
              />
            </div>

            <div className="d-flex flex-column w-3 field">
              <label className="label-field" htmlFor="publicDeedNumber">
                <FaGavel className="me-2" style={{ fontSize: "0.85em" }} />
                Escritura pública
              </label>
              <input
                id="publicDeedNumber"
                name="publicDeedNumber"
                autoComplete="off"
                maxLength={70}
                className={`input-field ${formErrors["publicDeedNumber"] ? "input-error" : ""}`}
                type="text"
                onChange={handleInputChange}
                value={form.publicDeedNumber}
                placeholder="Número de escritura"
              />
            </div>

            <div className="d-flex flex-column w-3 field">
              <label className="label-field" htmlFor="publicDeedDate">
                <FaCalendarAlt
                  className="me-2"
                  style={{ fontSize: "0.85em" }}
                />
                Fecha de escritura pública
              </label>
              <DateInput
                id="publicDeedDate"
                name="publicDeedDate"
                value={form.publicDeedDate}
                onChange={(date) => handleDateChange("publicDeedDate", date)}
                className={formErrors["publicDeedDate"] ? "input-error" : ""}
              />
            </div>

            <div className="d-flex flex-column w-3 field">
              <label className="label-field" htmlFor="notary">
                <FaGavel className="me-2" style={{ fontSize: "0.85em" }} />
                Notaría
              </label>
              <select
                className={`input-field ${formErrors["notary"] ? "input-error" : ""}`}
                id="notary"
                name="notary"
                onChange={handleInputChange}
                value={form.notary}
              >
                <option></option>
                {notaries.map((notary, index) => (
                  <option key={`${notary.name}${index}`} value={notary.name}>
                    {notary.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex flex-column w-3 field">
              <label className="label-field" htmlFor="servicesBill">
                <FaFileAlt className="me-2" style={{ fontSize: "0.85em" }} />
                Factura de servicios públicos
              </label>
              <input
                id="servicesBill"
                name="servicesBill"
                autoComplete="off"
                placeholder="Número de factura"
                maxLength={70}
                className={`input-field ${formErrors["servicesBill"] ? "input-error" : ""}`}
                type="text"
                onChange={handleInputChange}
                value={form.servicesBill}
              />
            </div>

            <div className="d-flex flex-column w-3 field">
              <label className="label-field" htmlFor="gasBill">
                <FaFileAlt className="me-2" style={{ fontSize: "0.85em" }} />
                Factura del gas
              </label>
              <input
                id="gasBill"
                name="gasBill"
                autoComplete="off"
                placeholder="Número de factura"
                maxLength={70}
                className={`input-field ${formErrors["gasBill"] ? "input-error" : ""}`}
                type="text"
                onChange={handleInputChange}
                value={form.gasBill}
              />
            </div>

            {/* Datos de Administración */}
            <div className="w-100 mb-4 mt-4">
              <h4 className="w-100 mb-3 pb-2 border-bottom">
                <FaCog className="me-2" style={{ color: "#76b4ff" }} />
                Datos de administración
              </h4>
            </div>

            <div className="d-flex flex-column w-50 field position-relative">
              <label className="label-field" htmlFor="ownerText">
                <FaUser className="me-2" style={{ fontSize: "0.85em" }} />
                Propietario del inmueble
              </label>
              <input
                type="text"
                autoComplete="off"
                className={`input-field ${formErrors["ownerText"] ? "input-error" : ""}`}
                id="user"
                placeholder="Buscar por nombres, apellidos o documento"
                onChange={handleSearchChange}
                name="ownerText"
                value={form.ownerText}
              />
              <div
                className={`dropdown-container ${
                  dropdown.show && dropdown.value === "ownerText"
                    ? "active"
                    : ""
                }`}
              >
                {dropdown.data.length > 0 ? (
                  dropdown.data.map((option, index) => (
                    <div
                      key={index}
                      className="dropdown-item-container"
                      onClick={() => setOwner(option)}
                    >
                      {option.firstName} {option.lastName} {option.documentType}{" "}
                      {option.document}
                    </div>
                  ))
                ) : (
                  <span className="dropdown-message-item">Sin resultados</span>
                )}
              </div>
            </div>

            <div className="d-flex flex-column w-50 field position-relative">
              <label className="label-field" htmlFor="administratorText">
                <FaUser className="me-2" style={{ fontSize: "0.85em" }} />
                Administrador del inmueble
              </label>
              <input
                type="text"
                autoComplete="off"
                className={`input-field ${formErrors["administratorText"] ? "input-error" : ""}`}
                id="user"
                placeholder="Buscar por nombres, apellidos o documento"
                onChange={handleSearchChange}
                name="administratorText"
                value={form.administratorText}
              />
              <div
                className={`dropdown-container ${
                  dropdown.show && dropdown.value === "administratorText"
                    ? "active"
                    : ""
                }`}
              >
                {dropdown.data.length > 0 ? (
                  dropdown.data.map((option, index) => (
                    <div
                      key={index}
                      className="dropdown-item-container"
                      onClick={() => setAdministrator(option)}
                    >
                      {option.firstName} {option.lastName} {option.documentType}{" "}
                      {option.document}
                    </div>
                  ))
                ) : (
                  <span className="dropdown-message-item">Sin resultados</span>
                )}
              </div>
            </div>

            <div className="d-flex flex-column w-33 field">
              <label className="label-field" htmlFor="managementTime">
                <FaCalendarAlt
                  className="me-2"
                  style={{ fontSize: "0.85em" }}
                />
                Duración
              </label>
              <select
                className={`input-field ${formErrors["managementTime"] ? "input-error" : ""}`}
                id="managementTime"
                name="managementTime"
                onChange={handleInputChange}
                value={form.managementTime}
              >
                <option></option>
                {agreementTimes.map((type, index) => (
                  <option key={`${type}${index}`} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex flex-column w-33 field">
              <label className="label-field" htmlFor="managementPercentage">
                <FaPercent className="me-2" style={{ fontSize: "0.85em" }} />
                Administración
              </label>
              <select
                className={`input-field ${formErrors["managementPercentage"] ? "input-error" : ""}`}
                id="managementPercentage"
                name="managementPercentage"
                onChange={handleInputChange}
                value={form.managementPercentage}
              >
                <option></option>
                {administrationValues.map((value, index) => (
                  <option key={`${value.value}${index}`} value={value.value}>
                    {value.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex flex-column w-33 field">
              <label className="label-field" htmlFor="minimumNotificationTime">
                <FaBell className="me-2" style={{ fontSize: "0.85em" }} />
                Notificación mín.
              </label>
              <select
                className={`input-field ${formErrors["minimumNotificationTime"] ? "input-error" : ""}`}
                id="minimumNotificationTime"
                name="minimumNotificationTime"
                onChange={handleInputChange}
                value={form.minimumNotificationTime}
              >
                <option></option>
                {notificationTimes.map((time, index) => (
                  <option key={`${time}${index}`} value={time}>
                    {time}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex flex-column w-50 field">
              <label className="label-field" htmlFor="bankAccount">
                <FaPiggyBank className="me-2" style={{ fontSize: "0.85em" }} />
                Cuenta para recibir pagos
              </label>
              <select
                className={`input-field ${formErrors["bankAccount"] ? "input-error" : ""}`}
                id="bankAccount"
                name="bankAccount"
                onChange={handleAccountChange}
                value={form.bankAccount._id}
              >
                <option></option>
                {accounts.map((account, index) => (
                  <option key={`${account}${index}`} value={account._id}>
                    No. {account.accountNumber} {account.accountType} -{" "}
                    {account.bank}{" "}
                  </option>
                ))}
              </select>
            </div>

            <div className="w-100 d-flex justify-content-center my-5">
              <button
                className="primary-button save-button"
                type="submit"
                style={{
                  padding: "12px 40px",
                  fontSize: "1.1em",
                  borderRadius: "6px",
                }}
              >
                <FaHome className="me-2" style={{ fontSize: "0.9em" }} />
                Guardar cambios
              </button>
            </div>
          </div>
        </form>

        {/* Herramientas */}
        <div className="w-100 my-5">
          <h4 className="w-100 mb-4 pb-2 border-bottom">
            <FaCog className="me-2" style={{ color: "#76b4ff" }} />
            Herramientas
          </h4>
          <div className="d-flex w-100 justify-content-center">
            <div
              className="d-flex flex-wrap gap-3"
              style={{ justifyContent: "flex-start", width: "100%" }}
            >
              {links.map((link, index) => {
                const isLink = link.name === "Copiar link solicitud"
                const ButtonComponent = isLink ? (
                  <CopyToClipboard
                    key={index}
                    text={`${forLink}${link.value}`}
                    onCopy={() =>
                      alert(
                        `El link fue copiado exitosamente: ${forLink}${link.value}`,
                      )
                    }
                  >
                    <button
                      style={{
                        padding: "10px 20px",
                        borderRadius: "6px",
                        border: "2px solid #76b4ff",
                        backgroundColor: "#f0f4ff",
                        color: "#76b4ff",
                        cursor: "pointer",
                        fontSize: "0.95em",
                        fontWeight: "500",
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#76b4ff"
                        e.target.style.color = "white"
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#f0f4ff"
                        e.target.style.color = "#76b4ff"
                      }}
                    >
                      <FaClipboard style={{ fontSize: "0.9em" }} />
                      {link.name}
                    </button>
                  </CopyToClipboard>
                ) : (
                  <Link
                    key={index}
                    to={link.value}
                    style={{
                      padding: "10px 20px",
                      borderRadius: "6px",
                      border: "2px solid #76b4ff",
                      backgroundColor: "#f0f4ff",
                      color: "#76b4ff",
                      textDecoration: "none",
                      fontSize: "0.95em",
                      fontWeight: "500",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#76b4ff"
                      e.currentTarget.style.color = "white"
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#f0f4ff"
                      e.currentTarget.style.color = "#76b4ff"
                    }}
                  >
                    <FaHome style={{ fontSize: "0.9em" }} />
                    {link.name}
                  </Link>
                )
                return ButtonComponent
              })}
            </div>
          </div>
        </div>

        {/* Documentos */}
        <div className="w-100 my-5">
          <h4 className="w-100 mb-3 pb-2 border-bottom">
            <FaFileAlt className="me-2" style={{ color: "#76b4ff" }} />
            Documentos
          </h4>
          <div className="d-flex flex-column gap-2">
            {documents.map((document, index) => (
              <Link
                key={index}
                to={`${currentLink}/${params.id}/documentos/${document.value}`}
                className="back-button"
                style={{
                  width: "fit-content",
                  paddingLeft: "1.5rem",
                  padding: "10px 16px",
                  borderRadius: "6px",
                  backgroundColor: "#f0f4ff",
                  color: "#76b4ff",
                  textDecoration: "none",
                  transition: "all 0.3s ease",
                }}
              >
                <FaFileAlt className="me-2" style={{ fontSize: "0.9em" }} />
                {document.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditProperty
